module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal1-6528e6e59c18b0acbc201ff5a9ac168c.jpg";